<template>
  <div style="background-color: #FFF; min-height: 100vh;">
    <!-- <a id="logo" href="https://alvarotrigo.com/fullPage/" alt="fullPage homepage">Enercred</a> -->
    <div class="text-xs-center" v-if="loading_inicio">
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
    </div>
    <div id="app" v-if="!loading_inicio">
      <!-- <ul id="menu" style="background-color:#000"></ul> -->
      <v-container fluid grid-list-md style="">
        <v-layout row wrap>
          <!-- logo  mobile-->
          <div class="hidden-md-and-up" style="padding: 3%;">
            <a
              href="https://enercred.com.br"
              target="_blank"
              alt="Enercred - Energia Limpa e Barata"
            >
              <img
                src="../../assets/logo.svg"
                width="150px"
                style="padding: 5px"
                alt="Enercred - Energia Limpa e Barata"
                class="src"
              />
            </a>
            <!-- Detalhe da assinatura para Mobile -->
            <v-flex xs12 sm12 md6 class="hidden-md-and-up pt-3">
              <cpnSteps :steps="{steps: 3, e1: 2}"/>
              <!-- <div class="pb-5 text-primary text--darken-3 text--large text-uppercase">Alugando uma fração de nossas usinas solares você tem:</div> -->
              <cpnOrderDetail :lead="lead" />
              <!-- <v-flex xs12 sm12 md12 style="text-align: center"> -->
              <!-- <div style="width: 70%">
                <cpnWhatsappButton/>
              </div> -->
              <!-- </v-flex> -->
            </v-flex>
          </div>
          <v-layout row wrap align-center justify-center fill-height style="height: 100vh; background: #efefef">
            <!-- Formulario de registro -->
            <v-flex d-flex xs12 sm12 md6 style="text-align: center">
              <div class="form_conta">
                <div class style="padding: 0">
                  <cpnSteps  class="hidden-sm-and-down" :steps="{steps: 3, e1: 2}"/>
                  <div
                    class="headline hidden-sm-and-up"
                    style="padding-bottom: 15px; color: #808080"
                  >ASSINATURA DE ENERGIA LIMPA</div>
                  <div
                    class="display-1 hidden-sm-and-down"
                    style="padding-bottom: 15px; color: #808080"
                  >ASSINATURA DE ENERGIA LIMPA</div>
                  <div class="red--text pb-4">Os dados a seguir devem ser do titular da conta de energia.</div>
                  <v-form ref="form" v-model="valid"  class="form_class">
                    <!-- CPF -->
                    <v-flex xs12>
                      <v-text-field
                        type="tel"
                        v-model="cpf"
                        label="CPF do titular da conta"
                        mask="###.###.###-##"
                        name="cpf"
                        :rules="[
                          v => !!v || 'Por favor, informe seu CPF!',
                          v => this.validaCPF(this.cpf) === true || 'CPF inválido'
                        ]"
												required
                      ></v-text-field>
                    </v-flex>

                    <!-- Titular ou familiar -->
                    <header style="text-align: left">Você é o titular da conta de luz?</header>
                    <v-radio-group
                      v-model="titular"
                      :rules="[
                        v => !!v || 'Por favor, informe sobre o titular da conta!'
                      ]"
                    >
                      <v-radio :key="1" :label="`Sou titular da Conta`" value="Sim"></v-radio>
                      <v-radio :key="2" :label="`Sou familiar do titular`" value="Familiar"></v-radio>
                    </v-radio-group>

                     <!-- Profissao -->
                    <v-flex xs12>
                      <v-text-field
                        v-model="profissao"
                        label="Profissão do titular da conta de energia"
                        name="profissao"
                        :rules="profissaoRules"
                        required
                      ></v-text-field>
                    </v-flex>
                    <!-- identidade -->
                    <v-flex xs12>
                      <v-text-field
                        v-model="identidade"
                        label="Identidade e órgão emissor"
                        name="identidade"
                        :rules="identidadeRules"
                        required
                      ></v-text-field>
                    </v-flex>
                    <!-- data de nascimento -->
                    <v-flex xs12>
                      <v-text-field
                        v-model="date_of_birth"
                        label="Data de nascimento do titular da conta de energia"
                        mask="##/##/####"
                        return-masked-value
                        name="date_of_birth"
                        :rules="[v => !!v || 'Informe a data de nascimento']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <!-- genero -->
                    <v-flex xs12>
                      <header style="padding-bottom: 4px;  text-align: left">Sexo do titular da conta?</header>

                      <v-radio-group
                        v-model="gender"
                        :rules="[v => !!v || 'Informe o sexo do titular da conta']"
                        row
                      >
                        <v-radio style="margin-right: 8px" label="Masculino" value="M"></v-radio>
                        <v-radio label="Feminino" value="F"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <!-- Estado civil -->
                    <v-flex xs12>
                      <header
                        style="padding-bottom: 4px; padding-left: 3px; text-align: left"
                      >Estado civil do titular da conta?</header>
                      <v-radio-group
                        v-model="estadoCivil"
                        row
                        @click="deselecionaRegimeDeBens()"
                        :rules="[v => !!v || 'Por favor, informe o estado civil do titular da conta!']"
                      >
                        <v-radio
                          v-for="(ec, index) in estadosCivis"
                          style="margin-right: 3px"
                          :key="index"
                          :label="ec"
                          :value="ec"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <!-- Comunhao de bens -->
                    <v-flex xs12>
                      <header
                        v-if="estadoCivil === 'Casado(a)'"
                        style="text-align: left; padding-bottom: 4px; padding-left: 3px"
                      >Qual Regime de Bens é casado(a). Comunhão:</header>
                      <v-radio-group v-if="estadoCivil === 'Casado(a)'" v-model="comunhaoDeBens">
                        <v-radio
                          v-for="(rdb, index) in regimeDeBens"
                          style="padding-right: 4px"
                          :key="index"
                          :label="rdb"
                          :value="rdb"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>


                    <!-- Forma de Pagamento -->
                    <header style="text-align: left">Forma de Pagamento</header>
                    <v-radio-group
                      v-model="payment_type"
                      :rules="[
                        v => !!v || 'Por favor, informe como deseja pagar sua energia limpa!'
                      ]"
                    >
                      <v-radio :key="1" :label="`Boleto`" value="boleto"></v-radio>
                      <v-radio :key="2" :label="`Cartão de Crédito`" value="credit_card"></v-radio>
                    </v-radio-group>

                    <!-- Termo de Compromisso -->
                    <v-flex xs12 style="text-align: left; padding: 0 0 0 7px; margin: 0">
                      <v-btn @click="dialog = true" color="primary">Ler Contrato</v-btn>
                    </v-flex>
                    <v-flex xs12>
                      <v-checkbox
                        v-model="termo"
                        @click="dialog = true;"
                        label="Aceito o contrato de assinatura de energia limpa"
                        :rules="[
                          v =>
                            !!v ||
                            'É necessário aceitar o contrato de aluguel para concluir o cadastro!'
                        ]"
                      ></v-checkbox>
                    </v-flex>
                    <div style="color: red; text-align: left">{{ alertMessage }}</div>
                    <!-- Botao assinar -->
                    <v-flex xs12 sm12 md12 style="text-align: right">
                      <div>
                        <v-btn
                          :loading="loading"
                          :disabled="!valid || loading"
                          block
                          @click.prevent="validate()"
                          large
                          style="background-color: rgb(9, 95, 150)"
                        >Assinar</v-btn>
                        <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=1928329&conversionId=1958089&fmt=gif" />
                      </div>
                    </v-flex>
                  </v-form>
                  <!-- <v-progress-circular v-if="loading" :size="50" color="teal" indeterminate></v-progress-circular> -->
                  <br />
                </div>
              </div>
            </v-flex>
            <!-- Enercred info -->
            <v-flex xs12 sm12 md6 style="text-align: center;">
              <div class="step2_esquerda" style="padding-top: 0">
                <div class="hidden-sm-and-down">
                  <a
                    href="https://enercred.com.br"
                    target="_blank"
                    alt="Enercred - Energia Limpa e Barata"
                  >
                    <img
                      src="../../assets/logo.svg"
                      width="180px"
                      style="padding: 5px"
                      alt="Enercred - Energia Limpa e Barata"
                      class="src"
                    />
                  </a>
                </div>
                <div>
                  <!-- <div class="hidden-sm-and-down pt-3 text-primary text--darken-5 text--large text-uppercase">Alugando uma fração de nossas usinas solares você tem:</div> -->
                  <cpnOrderDetail :lead="lead" class="hidden-sm-and-down pt-5" />
                </div>
                <div class="hidden-sm-and-down pt-5"></div>
              </div>
              <!-- <div class="hidden-sm-and-up pt-5"><cpnWhatsappButton/></div> -->
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </div>
    <div class="text-xs-center">
      <v-dialog v-model="dialog" width="500" scrollable>
        <v-card>
          <v-card-title class="headline grey lighten-2 pa-3" primary-title>Assinatura de Energia Limpa</v-card-title>

          <v-card-text class="pa-3">
            <cpnTermsOfUse />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="ml-auto">
            <v-spacer></v-spacer>
            <v-btn block color="secondary" @click="acceptUseOfTerms">ACEITAR</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-snackbar
      :color="color"
      :bottom="bottom"
      :top="top"
      :left="left"
      :right="right"
      v-model="snackbar"
      :timeout="timeout"
      dark
    >
      <v-icon
      color="white"
      class="mr-3"
      >
      mdi-bell-plus
      </v-icon>
      <div v-html="snackMessage"/>
      <v-icon
      size="16"
      @click="snackbar = false"
      >
      mdi-close-circle
      </v-icon>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
// import { enviarEmail } from "../../services/sendmail"
import { saveAnalytics } from "@/services/save_analytics"
// import { sendClooset } from "../../services/send_clooset"
// import { setMeliuz } from "../../services/set_meliuz"
// import { setRDConversion } from "@/services/rdstation";
import { STORE_LEAD, GET_LEAD } from "../../graphql/leads"
import { STORE_USER } from "../../graphql/users"
import { GET_PEOPLE } from "../../graphql/people"
import OrderDetail from "../../components/order/OrderDetail"
import TermsOfUse from "../../components/termsOfUse/TermsOfUse"
import { SET_CONVERSION } from "../../graphql/rdstation"
import Steps from '../../components/core/Steps'
import { getIP } from '../../services/getIP'
// import WhatsappButton from '../../components/core/WhatsappButton'
// import { storeUser } from '../../services/firebase/user'
import moment from 'moment'

export default {
  components: {
    cpnOrderDetail: OrderDetail,
    cpnTermsOfUse: TermsOfUse,
    cpnSteps: Steps,
    // cpnWhatsappButton: WhatsappButton
  },
  data() {
    return {
      loading_inicio: true,
      dialog: false,
      loading: false,
      cpf: "",
      titular: "",
      payment_type: "",
      estadosCivis: ["Solteiro(a)", "Casado(a)", "Separado(a)", "Divorciado(a)", "Viúvo(a)"],
      estadoCivil: "",
      profissao: "",
      profissaoRules: [value => !!value || "Por favor, informe a profissão!"],
      identidade: "",
      identidadeRules: [value => !!value || "Por favor, informe o numero de identidade!"],
      date_of_birth: "",
      gender: "",
      regimeDeBens: ["Parcial de bens", "Universal de bens", "Separação total", "Final nos aquestos"],
      comunhaoDeBens: "",
      termo: false,
      valid: false,
      isProd: false,
      lead: {},
      ipinfo: {},
      alertMessage: "",
      color: null,
			colors: [
					'purple',
					'info',
					'success',
					'warning',
					'error'
			],
			top: true,
			bottom: false,
			left: false,
      right: false,
      timeout: 36000,
			snackMessage: '',
			snackbar: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters["getUser"]
    },
    ...mapGetters(["getUser"])
  },
  async created() {
    this.loading_inicio = true
    this.isProd = process.env.NODE_ENV === "production"
    if(this.$route.query.email) {
      const email = this.$route.query.email
      console.log('email: ', email)
      await this.getLead(email)
        .then(lead => {
          this.setLead(lead.data.lead)
          this.loading = false
          this.loading_inicio = false
        })
        .catch(() => {
          console.error('Email não encontrado: ', email)
          this.loading = false
          this.loading_inicio = false
        })
    } else {
      const lead = JSON.parse(localStorage.getItem("lead"))
      // console.log('lead: ', lead)
      if(lead && lead.email) {
        this.setLead(lead)
      }
      this.loading = false
      this.loading_inicio = false
    }
  },
  methods: {
    formatDate(value) {
      if (!value) return ""
      const birthday = new Date(value.replace(/-/g, "/").replace(/T.+/, ""))
      return moment(birthday).format("DD/MM/YYYY")
    },
    async getLead(email) {
      return await this.$apollo.query({
        query: GET_LEAD,
        variables: {
          email: email
        }
      })
    },
    setLead(lead) {
      this.lead = lead
      this.cpf = lead.cpf
      this.titular = lead.titular
      // this.password = lead.password
      this.termouso = lead.termouso
      this.gender = lead.gender
      this.date_of_birth = lead.date_of_birth
      this.identidade = lead.ID_document
      this.payment_type = lead.payment_type
      this.profissao = lead.profession
      console.log('lead ->', lead)
    },
    async validate() {
      let campoCasadoPreenchido = false
      if (this.estadoCivil == "Casado(a)") {
        campoCasadoPreenchido = true
      }

      if (this.$refs.form.validate() && this.user && this.user.name && this.user.email) {
        this.loading = true
        if (campoCasadoPreenchido && this.comunhaoDeBens === undefined) {
          this.alertMessage = "Por favor preencha sua comunhão de bens!"
          this.loading = false
          return false
        }
        if (this.date_of_birth.length != 10) {
          this.alertMessage = "Date de nascimento inválida!"
          this.loading = false
          return false
        }
        this.alertMessage = ""
        const ipinfo = await getIP()
              
        const user = {
          ...this.user,
          cpf: this.cpf,
          titular: this.titular,
          password: this.cpf,
          termouso: this.termo,
          payment_type: this.payment_type || "boleto",
          status: "QUALIFICAR",
          signedcontract_ipinfo: ipinfo.data,
          signedcontract_at: new Date(),
          profession: this.profissao,
          ID_document: this.identidade,
          gender: this.gender,
          date_of_birth: this.date_of_birth,
          marital_status: this.estadoCivil,
          marital_type: this.comunhaoDeBens
        }
        if(this.payment_type === 'boleto') {
          user.boleto_accepted_by =  "onboarding",
          user.boleto_ipinfo = ipinfo.data
        }
        console.log('user: ' + user)

        // this.$store.commit("storeUserState", user)

        this.storeLead(user, 8)
          .then(result => {
            if (result.data) {
              localStorage.setItem("lead", JSON.stringify(user))
            }
          })
          .catch(err => {
            this.loading = false
            console.error("Error: ", err)
          })

        this.storeUser(user)
        // storeUser(user)
          .then((res) => {
            console.log(JSON.stringify(res))
            user.id = res.data.storeUser.id
            user.customer_id = res.data.storeUser.id
            this.$store.commit("storeUserState", user)
            localStorage.setItem("newUser", JSON.stringify(user))
            // analytics
            if (this.isProd) {
              const analytics = {
                eventCategory: "onboard",
                eventAction: "SIGN-CONTRACT",
                eventLabel: "enercred",
                transaction_id: user.email,
                value: this.lead.average_consumption,
                utm_source: this.lead.utm_source,
                utm_medium: this.lead.utm_medium,
                utm_campaign: this.lead.utm_campaign,
                payment_type: user.payment_type,
                boleto: this.payment_type === 'boleto'?true:false
              }
              if(user.promo_code) {
                analytics.referral_code = {
                  value: this.lead.average_consumption,
                  action: 'REFERRAL_SIGN-CONTRACT',
                  category: 'REFERRAL',
                  indicated: user.email,
                  indicator: user.promo_code
                }
              }
              saveAnalytics(analytics)
              const conversion = {
                event_type: "SALE",
                event_family: "CDP",
                payload: {
                  email: user.email,
                  funnel_name: "default",
                  value: this.lead.average_consumption,
                }
              }
              this.setRDConversion(conversion)
              // const closset = {
              //   id: res.data.storeUser.id || user.email,
              //   // order_value: Number(user.average_consumption)
              //   order_value: 50
              // }
              // sendClooset(closset)
              // if(this.lead.utm_source === 'meliuz' && this.lead.utm_transaction) {
              //   // setMeliuz(this.lead.utm_transaction, parseFloat(user.average_consumption), res.data.storeUser.id)
              // }
            }
            if(this.user.payment_type === 'boleto') {
              this.$router.push("/cadastro-boas-vindas")
            } else {
              this.$router.push("/cadastro/cartao")
            }
            this.loading = false
            return true
          })
          .catch(error => {
            let msg = 'Erro ao gravar informações. Por favor, contate nosso suporte em (31) 3500-3614 ou whatsApp <a href="https://wa.me/5535998625580?text=' + error + '">(35) 99862-5580</a>.'
            if(error.toString().includes('already')) {
              msg = 'O email já está sendo utilizado! Por favor, contate nosso suporte em (31) 3500-3614 ou whatsApp <a href="https://wa.me/5535998625580?text=' + error + '">(35) 99862-5580</a>.'
            }
            console.error(msg)
            this.snack(msg, 'red', 'top')
            this.loading = false
            return false
          })
      } else {
        alert("Desculpe, houve algum erro ao salvar, reiniciaremos o seu cadastro!")
        this.$router.push("cadastro")
      }
    },
    async getPeople(cpf) {
      return await this.$apollo.query({
        query: GET_PEOPLE,
        variables: {
          doc: cpf
        }
      })
    },
    acceptUseOfTerms() {
      this.termo = true
      this.dialog = false
    },
    storeUser(user) {
      const group = "customer"
      return this.$apollo.mutate({
        // Query
        mutation: STORE_USER,
        // Parameters
        variables: {
          email: user.email,
          name: user.completeName || user.name || "",
          cpf: user.cpf,
          phone: user.phone,
          group: group,
          profession: user.profession,
          marital_status: user.marital_status,
          marital_type: user.marital_type,
          gender: user.gender || "",
          ID_document: user.ID_document,
          status: "QUALIFICAR",
          date_of_birth: user.date_of_birth,
          payment_type: user.payment_type || "credit_card",
          // referral_balance: process.env.VUE_APP_REFERRAL_VALUE_INDICADO,
          // referral_reward: process.env.VUE_APP_REFERRAL_VALUE_INDICADOR,
          // password: user.password,
          average_consumption: this.lead.average_consumption,
          boleto_accepted_by: user.boleto_accepted_by,
          boleto_ipinfo: user.boleto_ipinfo,
          signedcontract_ipinfo: user.signedcontract_ipinfo,
          signedcontract_at: user.signedcontract_at,
          signedcontract_by: 'onboarding',
          signedcontract_source: 'online',
          signedcontract_partner: 'enercred',
        }
      })
    },
    storeLead(lead, step) {
      return this.$apollo.mutate({
        // Query
        mutation: STORE_LEAD,
        // Parameters
        variables: {
          id: lead.email,
          email: lead.email,
          name: lead.name,
          cpf: lead.cpf,
          phone: lead.phone,
          average_consumption: lead.average_consumption,
          step: step,
          classe: lead.classe,
          concessionaria: lead.concessionaria,
          titular: lead.titular,
          termouso: lead.termouso == true ? "Sim" : "Nao",
          zipcode: lead.zipcode,
          promo_code: lead.promo_code,
          utm_source: lead.utm_source,
          utm_medium: lead.utm_medium,
          utm_campaign: lead.utm_campaign,
          utm_transaction: lead.utm_transaction,
          ID_document: lead.ID_document,
          profession: lead.profession,
          marital_status: lead.marital_status,
          marital_type: lead.marital_type,
          gender: lead.gender || "",
          signedcontract_at: lead.signedcontract_at,
        }
      })
    },
    validaCPF(strCPF) {
      if (!strCPF) return ""
      var Soma
      var Resto
      Soma = 0
      if (strCPF == "00000000000") return false

      for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i)
      Resto = (Soma * 10) % 11

      if (Resto == 10 || Resto == 11) Resto = 0
      if (Resto != parseInt(strCPF.substring(9, 10))) return false

      Soma = 0
      for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i)
      Resto = (Soma * 10) % 11

      if (Resto == 10 || Resto == 11) Resto = 0
      if (Resto != parseInt(strCPF.substring(10, 11))) return false
      console.log(strCPF, this.cpf)
      this.buscaDadosComplementares()
      return true
    },
    async buscaDadosComplementares(){
      if(this.cpf && this.cpf != ''){
        await this.getPeople(this.cpf).then(people => {
          console.log('people:', people)
          if (
            typeof people !== "undefined" &&
            people !== null &&
            typeof people.data !== "undefined" && people.data !== null &&
            typeof people.data.people !== "undefined" && people.data.people !== null &&
            typeof people.data.people.Result[0] !== "undefined" && people.data.people.Result[0] !== null &&
            typeof people.data.people.Result[0].BasicData !== "undefined" &&
              people.data.people.Result[0].BasicData !== null
          ) {
            console.log('people gender', people.data.people.Result[0].BasicData.Gender)
            this.user.name = people.data.people.Result[0].BasicData.Name || this.user.name
            if(!this.gender || this.gender === "") this.gender = people.data.people.Result[0].BasicData.Gender || ""
            if(!this.date_of_birth || this.date_of_birth === "") this.date_of_birth = this.formatDate(people.data.people.Result[0].BasicData.BirthDate) || ""
            if(typeof people.data.people.Result[0].BasicData.AlternativeIdNumbers !== "undefined" &&
              people.data.people.Result[0].BasicData.AlternativeIdNumbers !== null && people.data.people.Result[0].BasicData.AlternativeIdNumbers.RG){
              if(!this.identidade || this.identidade === "") this.identidade = people.data.people.Result[0].BasicData.AlternativeIdNumbers.RG || ""
            }
          }
        })
      }
      console.log('this gender ', this.gender)
    },
    // Quando seleciona estado civil reseta comunhao de bens
    deselecionaRegimeDeBens() {
      this.comunhaoDeBens = undefined
      this.alertMessage = ""
    },
    setRDConversion(conversion) {
      return this.$apollo.mutate({
        // Query
        mutation: SET_CONVERSION,
        // Parameters
        variables: {
          event_type: conversion.event_type,
          event_family: conversion.event_family,
          payload: conversion.payload
        }
      })
    },
    snack (message, color, ...args) {
			this.top = false
			this.bottom = false
			this.left = false
			this.right = false

			for (const loc of args) {
					this[loc] = true
			}

			this.color = color
			this.snackMessage = message
			this.snackbar = true
		},
  },
  mounted() {
    this.loading_inicio = false
  }
}
</script>

<style scoped>
@charset "ISO-8859-1";
/* Reset CSS
 * --------------------------------------- */
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td {
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none;
}

fieldset,
img {
  border: 0;
}
ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
caption,
th {
  text-align: left;
}
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
  font-size: 100%;
  margin: 0;
  padding: 0;
}
q:before,
q:after {
  content: "";
}
abbr,
acronym {
  border: 0;
}
* {
  -webkit-box-sizing: border-box; /* Safari<=5 Android<=3 */
  -moz-box-sizing: border-box; /* <=28 */
  box-sizing: border-box;
}

/* Custom
 * --------------------------------------- */
html,
body {
  height: 100%;
  background-color: #095f96;
}
template {
  background-color: #095f96;
}
.area {
  height: 100px;
  width: 100px;
  background: red;
  margin: 10px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}
.content {
  height: 100px;
  width: 100px;
  display: table-cell;
  vertical-align: middle;
}
.header {
  font-size: 2em;
  height: 550px;
  vertical-align: -webkit-baseline-middle;
  vertical-align: middle;
  display: table-cell;
  color: #fff;
}
.header span {
  font-size: 2em;
  color: #fff;
  font-weight: bold;
}
.header br {
  font-size: 4em;
  color: #fff;
  font-weight: bold;
}
.form_conta {
  height: 100vh;
  vertical-align: -webkit-baseline-middle;
  vertical-align: middle;
  background-color: #fff;
  padding: 1% 5% 10% 5%;
  text-align: center;
  /* border-radius: 10px; */
}
.step2_esquerda {
  width: 95%;
  padding-left: 5%;
  padding-top: 10%;
  text-align: left;
}
/*
.form_class {
  padding-top: 100px;
  height: 550px;
  vertical-align: -webkit-baseline-middle;
  vertical-align: middle;
  text-align: center;
}
*/
.section {
  position: relative;
  text-align: center;
}
#section-1 h2 {
  color: #fff;
  font-size: 10em;
  font-weight: 900;
}
#section-1 h1 {
  font-size: 2em;
  font-weight: 100;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  margin: 1.5em auto 1em auto;
  color: #00a8bb;
  padding-right: 30px;
  padding-left: 30px;
}
#section-1 li {
  display: inline-block;
  margin: 1.25em 0.3em;
}
.section-1-button {
  padding: 0.93em 1.87em;
  background: #00a8bb;
  border-radius: 5px;
  display: block;
  color: #fff;
}
#section-1 h2 {
  color: #fff;
  font-size: 10em;
  font-weight: 500;
}
#section-3 h1 {
  font-size: 2em;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  margin: 1.5em auto 1em auto;
  color: #00a8bb;
  padding-right: 30px;
  padding-left: 30px;
}
#section-3 li {
  display: inline-block;
  margin: 1.25em 0.3em;
}
.section-3-button {
  padding: 0.93em 1.87em;
  background: #35495e;
  border-radius: 5px;
  display: block;
  color: #fff;
}
#section-3 .intro {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  width: 50%;
  padding: 0 3em;
}

h3 {
  font-size: 4em;
  /* text-align: center; */
  color: #fff;
  font-weight: bold;
}
h2 {
  font-size: 2em;
  /* text-align: center; */
  color: #fff;
  font-weight: bold;
}
#logo {
  position: fixed;
  top: 20px;
  left: 20px;
  color: #fff;
  font-weight: bold;
  z-index: 99;
  font-size: 1.9em;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
}
.progress-bar {
  margin: 10px 0;
}
input[type="file"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

.atencao {
  font-size: 1.5em;
  color: #00a8bb;
  font-weight: bold;
}

/* Menu
 * --------------------------------------- */
#menu-line {
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 159px;
  height: 2px;
  background: #fff;
}

#menu {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 70;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  letter-spacing: 1px;
  font-size: 1.1em;
}
#menu li {
  display: inline-block;
  margin: 10px 0px;
  position: relative;
}
#menu a {
  color: #fff;
  padding: 0 1.1em 1.1em 1.1em;
}
#menu li.active a:after {
  content: "";
  margin: 0 1.1em 0 1.1em;
  height: 2px;
  background: #fff;
  display: block;
  position: absolute;
  bottom: -6px;
  left: 0;
  right: 0;
  display: block;
}

/* Actions buttons
 * --------------------------------------- */
.actions {
  position: fixed;
  bottom: 2%;
  margin: 0 auto;
  z-index: 99;
  left: 0;
  right: 0;
  text-align: center;
}
.actions li {
  display: inline-block;
  margin: 0.3em 0.3em;
}
.actions-button {
  padding: 0.73em 1.47em;
  background: rgba(53, 73, 94, 0.47);
  border-radius: 5px;
  display: block;
  color: #fff;
  cursor: pointer;
}

/* Twitter
 * --------------------------------------- */
.twitter-share i {
  vertical-align: middle;
  position: relative;
  top: 2px;
  display: inline-block;
  width: 38px;
  height: 14px;
  color: white;
  top: -4px;
  left: -2px;
  fill: #fff;
}
.twitter-share svg {
  height: 40px;
  margin-top: -10px;
}
.view-github {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 999;
  padding: 0.93em 1.87em;
  background: #35495e;
  border-radius: 5px;
  display: block;
  color: #fff;
}

.shell {
  width: calc(50% - 0px);
  display: inline-block;
  background-color: #fff;
  /*  background-image: url('../assets/eolica.png'); */
  background-position: center;
  border-radius: 0px 0px 0 0;
  text-align: left;
  margin-right: 0px;
}
</style>
